module.exports = __webpack_public_path__ + "static/media/redlink.77dccdd2.png";